import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { CompanyInfo } from 'src/app/shared/models/company';

export class CogsPdfGenerator {
  generatePdf(data: any, companyInfo: CompanyInfo, period: string, startDate: string, endDate: string): jsPDF {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'pt',
      format: 'letter'
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 40;
    let yPosition = 40;

    // Header - Company Name
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text(companyInfo?.company_name || 'COGS Report', margin, yPosition);
    yPosition += 25;

    // Report Subtitle
    doc.setFontSize(14);
    doc.setFont('helvetica', 'normal');
    doc.text('Cost of Goods Sold Statement', margin, yPosition);
    
    // Period Label
    const periodStr = period === 'Custom' ? `${startDate} to ${endDate}` : period;
    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(`Period: ${periodStr}`, margin, yPosition + 15);
    
    yPosition += 50;

    // Summary Section
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0);
    doc.text('Summary Overview', margin, yPosition);
    yPosition += 15;

    const summaryRows = [
      ['Beginning Inventory', `$${(data.beginningInventory || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}`],
      ['(+) Purchases', `$${(data.purchases || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}`],
      ['(-) Cost of Goods Sold', `$${(data.totalCogs || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}`],
      ['Ending Inventory', `$${(data.endingInventory || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}`]
    ];

    autoTable(doc, {
      startY: yPosition,
      head: [['Metric', 'Amount']],
      body: summaryRows,
      margin: { left: margin },
      styles: { fontSize: 10 },
      headStyles: { fillColor: [44, 62, 80] },
      columnStyles: {
        1: { halign: 'right', fontStyle: 'bold' }
      }
    });

    yPosition = (doc as any).lastAutoTable.finalY + 40;

    // Breakdown Table
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Inventory Valuation by Category', margin, yPosition);
    yPosition += 15;

    const breakdownRows = data.breakdown.map((row: any) => [
      row.category,
      `$${(row.beginning || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}`,
      `$${(row.purchased || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}`,
      `$${(row.cogs || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}`,
      `$${(row.ending || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}`
    ]);

    autoTable(doc, {
      startY: yPosition,
      head: [['Category', 'Beginning', 'Purchased', 'COGS', 'Ending Value']],
      body: breakdownRows,
      margin: { left: margin },
      styles: { fontSize: 9 },
      headStyles: { fillColor: [255, 77, 77] },
      columnStyles: {
        1: { halign: 'right' },
        2: { halign: 'right' },
        3: { halign: 'right' },
        4: { halign: 'right', fontStyle: 'bold' }
      }
    });

    // Footer
    const pageCount = (doc as any).internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(150);
      doc.text(
        `Generated on ${new Date().toLocaleString()} - Page ${i} of ${pageCount}`,
        pageWidth / 2,
        doc.internal.pageSize.getHeight() - 20,
        { align: 'center' }
      );
    }

    return doc;
  }
}
